<div class="block form-admin" [loading]="loading">
	<header class="header-admin">
		<h1 class="admin">Produits</h1>
		<div class="actions">
			<a href="" [routerLink]="route.get('product-form')"><i class="fa-solid fa-layer-plus"></i></a>
			<a (click)="export()"><i class="fa-solid fa-download"></i></a>
		</div>
	</header>
	<router-outlet></router-outlet>
</div>